<template>
	<div class="control sluzebka_options col-lg-4 col-xl-3 col-sm-4 col-xs-12 ">
		<div class="panel">
			<div class="panel-hdr">
				<h2>Ініціатор </h2>
			</div>

			<div class="panel-container">
				<div class="intro p-2">
					<user_block key="init_user" v-bind:user=init_user></user_block>
				</div>
			</div>
		</div>

		<div v-if="can_select_adjust" class="panel ">
			<div class="panel-hdr">
				<h2>Погодження </h2>

				<div class="panel-toolbar">
					<button class="btn  btn-primary shadow waves-effect waves-themed pr-3 pl-3"  v-on:click="show_users('before')">
						<i class="fal fa-user-plus"></i>
						додати до
					</button>
				</div>
			</div>

			<div class="panel-container p-2">

				<!-- before adjust  -->
				<draggable class="adj_move u_list p-2" v-model="adj_added" v-if="adj_added.length > 0" v-bind="dragOptions('before')">
					<user_block
						v-for="(item,idx) in adj_added"
						:key="item.id"
						class="mb-1"
						v-bind:can_del=true
						v-bind:del_triger="remove_triger"
						v-bind:user="item">
					</user_block>
				</draggable>

				<!-- director -->
				<div class="u_list  text-white p-2" id="approve_list" v-if="active_mem.is_dir_active">
					<user_block class="bg-primary-50" key="dir_user" v-bind:del_triger="remove_dir" v-bind:user="org_dir" v-bind:can_del=true></user_block>
				</div>

				<!-- adj_users -->
				<div class="user_list u_list p-2" v-if="mem_adjust.length > 0">
					<div class="isp_list">
						<user_block v-for="(item) in mem_adjust" :key="'adj_' + item.id" v-bind:user="item"  class="mb-1" :class="classBlockUser(item)"></user_block>
					</div>
				</div>

				<!-- after adjust -->
				<draggable class="adj_move u_list p-2" v-model="adj_added_after" v-if="adj_added_after.length > 0" v-bind="dragOptions('after')">
					<user_block
						v-for="(item) in adj_added_after"
						:key="item.id"
						class="mb-1"
						v-bind:can_del=true
						v-bind:del_triger="remove_triger_after"
						v-bind:user="item">
					</user_block>
				</draggable>

			</div>

			<div class="panel-hdr">
				<h2></h2>
				<div class="panel-toolbar">
					<button class="btn зк-3 зд-3 btn-primary shadow waves-effect waves-themed float-right "  v-on:click="show_users('after')">
						<i class="fal fa-user-plus"></i>
						Додати після
					</button>
				</div>

			</div>

		</div>

		<div class="panel  ">
			<div class="panel-hdr">
				<h2>Виконання </h2>
			</div>

			<div class="panel-container">
				<div class="intro p-2">
					<user_block :key="'isp_id_' + isp_id" v-bind:user_id=parseInt(isp_id)></user_block>
				</div>
			</div>
		</div>

		<div class="panel  ">
			<div class="panel-hdr">
				<h2>Файли </h2>
			</div>

			<div class="panel-container p-2">
				<fileloader
					key="file_loader_mem"
					doc_type="memorandum" v-bind:trigger_load="load_triger" v-bind:can_del="true">
				</fileloader>
			</div>
		</div>
	</div>

</template>

<script>

import user_block from "../../../../shared/user/user_block/user_block.vue";
import fileloader from "../../../../shared/file_loader/fileloader.vue";
import draggable from 'vuedraggable'



import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
	getterType: 'memorandum_create/getMemCreateField',
	mutationType: 'memorandum_create/updateMemCreateField',
});

export default {
	name: "mem_preview_right",
	components: {
		fileloader,
		user_block,
		draggable,
	},

	props: {
		remove_dir: {
			type: String,
			default: "remove_dir",
		},
  
		remove_triger: {
			type: String,
			default: "remove_adjust",
		},

		remove_triger_after: {
			type: String,
			default: "remove_adjust_after",
		},

		load_triger: {
			type: String,
			default: "loader_load_file",
		},
	},
	data() {
		return {
			//adjust_added: [],
			//ajsut_added_after: [],
		}
	},

	mounted() {

		if (myapp_config.debugState)
			console.log("%c✔ mem_right_init", "color: #148f32");

		//add adjust list
		EventBus.$on('selected_users', e => {

			if (e.uniq === 'adjust_users') {
				this.$store.dispatch('memorandum_create/DEL_ACTIVE_MEMORANDUM_ADJUST');
				this.adj_added = e.users;
			}

			if (e.uniq === 'adjust_users_after') {
				this.$store.dispatch('memorandum_create/DEL_ACTIVE_MEMORANDUM_ADJUST_AFTER');
				this.adj_added_after = e.users;
			}
		});

		//dir remove
		EventBus.$on(this.remove_dir, e => {
			if (myapp_config.debugState)
				console.log("%c|___REMOVE_DIR", "color: #ffc241",e);

			this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM', {is_dir_active: false})
		});

		//adj  remove
		EventBus.$on(this.remove_triger, e => {
			if (myapp_config.debugState)
				console.log("%c|___REMOVE_USER_BEFORE", "color: #ffc241",e);
			this.remove_adj_user(e, 'before');
		});

		//adj  remove after
		EventBus.$on(this.remove_triger_after, e => {
			if (myapp_config.debugState)
				console.log("%c|___REMOVE_USER_AFTER", "color: #ffc241",e);

			this.remove_adj_user(e, 'after');
		});


		//file loaded
		EventBus.$on(this.load_triger, e => {
			if (myapp_config.debugState)
				console.log("%c|___FILE_ACTION", "color: #ffc241",e);

			this.work_files(e);
		});
	},

	created() {
		setTimeout(() => {
        		if (this.active_mem.organization.id === 21) {
                		EventBus.$emit('remove_dir');
            		}
        	}, 500);

	},

	methods: {

		work_files: function (res) {
			console.log(res);

			if (res != undefined) {
				if (res.type === 'file_loaded') {
					this.mem_files.push(res);
				}

				if (res.type === 'file_deleted') {
					for (let i = this.mem_files.length - 1; i >= 0; i -= 1) {
						if (parseInt(this.mem_files[i].file_id) === parseInt(res.file_id)) {
							this.mem_files.splice(i, 1);
						}
					}
				}
			}
		},

		remove_adj_user: function (user, type) {
			let adj = null;
			if(type === 'after') {
				adj = this.adj_added_after;
			}

			if(type === 'before') {
				adj = this.adj_added;
			}

			if(adj != null) {
				for (let i = adj.length - 1; i >= 0; i -= 1) {
					if (adj[i].id === user.id) {
						adj.splice(i, 1);
					}
				}
			}
		},


		protected_filter_users(active) {
			//Base exclude
			let exclude = JSON.parse(JSON.stringify(this.mem_adjust));

			if (active.length > 0) {
				if (exclude.length > 0) {
					for (let i = active.length - 1; i >= 0; i -= 1) {
						exclude.push(active[i]);
					}
					return exclude;
				} else {
					return active;
				}
			}

			return exclude;
		},

		filter_adjust_exclude: function (type) {

			if (type === 'before') {
				let active = JSON.parse(JSON.stringify(this.adj_added_after));
				return this.protected_filter_users(active);
			}

			if (type === 'after') {
				let active = JSON.parse(JSON.stringify(this.adj_added));
				return this.protected_filter_users(active);
			}

		},

		filter_adjust_active: function (type) {
			if (type === 'after') {
				return JSON.parse(JSON.stringify(this.adj_added_after));
			}

			if (type === 'before') {
				return JSON.parse(JSON.stringify(this.adj_added));
			}
		},


		show_users: function (type = 'after') {
			let uniq = 'adjust_users';

			if (type === 'after') {
				uniq = 'adjust_users_after';
			}

			EventBus.$emit('load_users_filter', {
				'exclude': this.filter_adjust_exclude(type),
				'active': this.filter_adjust_active(type),
				uniq: uniq
			});
		},

		dragOptions(type) {
			return {
				animation: 200,
				group: "description" + type,
				disabled: false,
				ghostClass: "ghost"
			};
		},
  
		classBlockUser(user) {
			const user_name = user?.user_name_redirect ?? '';
			return user_name !== '' ? 'redirect_bg' : 'adjust_bg'
		}
	},
	computed: {

		...mapFields([
			'active_memorandum'
		]),


		active_mem() {
			return this.active_memorandum;
		},

		can_select_adjust() {
			return this.active_mem.show_adjust;
		},

		recipient: function recipient() {
			return this.active_mem.recipient;
		},

		init_user() {
			return this.active_mem.cur_user;
		},

		isp_id() {
			return this.active_mem.isp.isp_id;
		},

		dir_id() {
			return this.active_mem.organization.director_id;
		},

		org_dir() {
			return this.active_mem.director;
		},

		adj_added: {
			get() {
				return this.active_mem.adjust_added;
			},
			set(arr) {
				this.$store.dispatch('memorandum_create/SET_ACTIVE_MEMORANDUM_ADJUST', arr);
			}
		},

		adj_added_after: {
			get() {
				return this.active_mem.adjust_added_after;
			},
			set(arr) {
				this.$store.dispatch('memorandum_create/SET_ACTIVE_MEMORANDUM_ADJUST_AFTER', arr);
			}
		},
  
		mem_files: {
			get() {
				return this.active_mem.files;
			},
			set(arr) {
				this.$store.dispatch('memorandum_create/SET_ACTIVE_MEMORANDUM_FILES', arr);
			}
		},

		mem_adjust() {
			return this.active_mem?.adjust_user ?? [];
		},

		beforeDestroy() {
			console.log('kill right_side');

			if (myapp_config.debugState)
				console.log("%c✔ kill right_side", "color: #ffc241");
		},

		destroyed: function () {
			if (myapp_config.debugState)
				console.log("%c✔ kill mem_preview_right", "color: #ffc241");
		}
	},

	watch: {
		dir_id: function (val) {
			if (myapp_config.debugState)
				console.log("%c|___DIR_UPD", "color: #ffc241",val);

			try {
				if (this.dir_id == this.recipient.user_id) {
					EventBus.$emit();
				}
			} catch (e) {
				console.error(e);
			}
		},

	}
}
</script>

<style scoped>
.flip-list-move {
	transition: transform 0.5s;
}

.no-move {
	transition: transform 0s;
}

.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

.list-group {
	min-height: 20px;
}

.list-group-item {
	cursor: move;
}

.list-group-item i {
	cursor: pointer;
}

.adj_move {
	cursor: move;
}

.u_list {
	/*  box-shadow: 0 5px 5px #999;
	  margin-bottom: 10px;
	  border-top: 8px solid #eee;
	  position: relative;*/
}

.u_list .user_profile {
	padding-top: 2px;
	padding-bottom: 2px;
}


.adjust_bg {
	background: #eef7e7;
}

.redirect_bg {
	background: #77f8ea;
}

</style>
